import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="N" transform="translate(35.000000, 32.000000)">
        <path
          d="M32.1572 36H22.5381L7.01074 8.99805H6.79102C6.85612 10.1211 6.91309 11.2523 6.96191 12.3916C7.01074 13.5309 7.05957 14.6702 7.1084 15.8096C7.15723 16.9326 7.20605 18.0638 7.25488 19.2031V36H0.492188V0.306641H10.0381L25.541 27.04H25.7119C25.6794 25.9333 25.6387 24.8346 25.5898 23.7441C25.541 22.6536 25.4922 21.5632 25.4434 20.4727C25.4108 19.3822 25.3783 18.2917 25.3457 17.2012V0.306641H32.1572V36Z"
          fill="#64FFDA"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
